The overarching phase that the status corresponds to.

This can be omitted if your software does not model such a hierarchy.
